import { Component, EventEmitter, inject, Output } from '@angular/core';
import { AppConfig } from '@app/core/app.config';

@Component({
    selector: 'image-uploader-preview',
    templateUrl: './image-uploader-preview.component.html',
    styleUrls: ['./image-uploader-preview.component.scss'],
    standalone: false
})
export class ImageUploaderPreviewComponent {
  protected srcImg: string;
  protected fileSizeError = false;
  protected fileTypeError = false;
  protected appConfig = inject(AppConfig);

  @Output()
  public imageSelected = new EventEmitter<string | ArrayBuffer | null>();

  /**
   * Emit the selected image as base64.
   * @param image image File.
   */
  private emitSelectedImage(image: File): void {
    if (!image) return this.imageSelected.emit(null);
    const reader = new FileReader();
    reader.onloadend = (): void => this.imageSelected.emit(reader.result);
    reader.readAsDataURL(image);
  }

  /**
   * Load and show the selected image in the preview area.
   * If the image is invalid, reset the preview area.
   * If no picture is selected, do nothing.
   * @param event
   */
  public previewImage(event: Event): void {
    const file = (event.target as HTMLInputElement).files[0];
    if (!file) return;

    this.fileSizeError = file.size > this.appConfig.MAX_FILE_SIZE;
    this.fileTypeError = !this.appConfig.ALLOWED_LOGO_IMAGE_TYPE.includes(file.type);

    // Reset preview if the uploaded picture is invalid
    if (this.fileSizeError || this.fileTypeError) {
      this.srcImg = null;
      this.emitSelectedImage(null);
    } else {
      this.srcImg = URL.createObjectURL(file);
      this.emitSelectedImage(file);
    }
  }
}
